var createStylesheet = function(fullhref, resolve, reject) {
	var linkTag = document.createElement("link");
	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	linkTag.onload = resolve;
	linkTag.onerror = function(event) {
		var request = event && event.target && event.target.src || fullhref;
		var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
		err.code = "CSS_CHUNK_LOAD_FAILED";
		err.request = request;
		linkTag.parentNode.removeChild(linkTag)
		reject(err);
	};
	linkTag.href = fullhref;

	var head = document.getElementsByTagName("head")[0];
	head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"umi": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_global_less":1,"src_components_RightContent_index_less_modules":1,"src_components_HeaderDropdown_index_less_modules":1,"src_umi_plugin-layout_layout_layout_style_less":1,"src_pages_user_Login_index_less_modules":1,"src_components_RichText_Index_less":1,"src_pages_category_index_less_modules":1,"src_components_HeaderSearch_index_less_modules":1,"src_components_NoticeIcon_index_less_modules":1,"src_components_NoticeIcon_NoticeList_less_modules":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

var oldTags = [];
var newTags = [];
var applyHandler = function(options) {
	return { dispose: function() {
		for(var i = 0; i < oldTags.length; i++) {
			var oldTag = oldTags[i];
			if(oldTag.parentNode) oldTag.parentNode.removeChild(oldTag);
		}
		oldTags.length = 0;
	}, apply: function() {
		for(var i = 0; i < newTags.length; i++) newTags[i].rel = "stylesheet";
		newTags.length = 0;
	} };
}
__webpack_require__.hmrC.miniCss = function(chunkIds, removedChunks, removedModules, promises, applyHandlers, updatedModulesList) {
	applyHandlers.push(applyHandler);
	chunkIds.forEach(function(chunkId) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		var oldTag = findStylesheet(href, fullhref);
		if(!oldTag) return;
		promises.push(new Promise(function(resolve, reject) {
			var tag = createStylesheet(fullhref, function() {
				tag.as = "style";
				tag.rel = "preload";
				resolve();
			}, reject);
			oldTags.push(oldTag);
			newTags.push(tag);
		}));
	});
}